/* eslint-disable max-len, no-console, no-undef */
import $ from 'jquery';

$(document).ready(() => {
  require.ensure(['leaflet/dist/leaflet-src'], (require) => {
    require('leaflet/dist/leaflet-src');

    const $map = $('.js-map');

    if (!$map.length) {
      return;
    }

    const latitude = $map.data('latitude');
    const longitude = $map.data('longitude');
    const officeName = $map.data('office-name');
    const offices = $map.data('offices');
    console.log(offices);

    const mymap = L.map('mapid');

    const pin = L.icon({
      iconUrl: '/SiteFiles/src/img/icon.png',

      iconSize: [32, 47], // size of the icon
      iconAnchor: [16, 47], // point of the icon which will correspond to marker's location
      popupAnchor: [0, -60], // point from which the popup should open relative to the iconAnchor
    });

    L.tileLayer('https://api.mapbox.com/styles/v1/secontrols/cjendpmq4enpt2ro6pdc4dnhr/tiles/256/{z}/{x}/{y}?access_token={accessToken}', {
      attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
      maxZoom: 18,
      accessToken: 'pk.eyJ1Ijoic2Vjb250cm9scyIsImEiOiJjamRlZ3VvenkwYzg2Mnlvbm90NGw2Y3psIn0.ubtAYGK0aB0KOqzQ9eo11g',
    }).addTo(mymap);

    // head office
    const marker = L.marker([latitude, longitude], { icon: pin }).addTo(mymap);
    marker.bindPopup(`<h3 class="map__title">${officeName}</h3>`).openPopup();

    const bounds = [];

    if (offices) {
      offices.forEach((office) => {
        if (office.Latitude && office.Longitude) {
          const officeMarker = L.marker([office.Latitude, office.Longitude], { icon: pin }).addTo(mymap);
          officeMarker.bindPopup(`<h3 class="map__title">${office.OfficeName}</h3>`).openPopup();
          bounds.push(L.latLng(office.Latitude, office.Longitude));
        }
      });
    }

    // central location based on all office locations
    bounds.push(L.latLng(latitude, longitude));
    mymap.fitBounds(bounds);
  });
});
